import { PhotoObjectDto } from "./PhotoObjectDto";

export class InsidePhotoDto {
  id: string;
  surveyId: string;
  mimeType: string;
  originalPhotoData: string;
  originalBlob: Blob;
  photoData: string;
  blob: Blob;
  type: number;
  items: PhotoObjectDto[];
  backgroundImageMetadata: string;
  index: number;
  b64Parsed: boolean = false;

  constructor(obj: Partial<InsidePhotoDto>) {
    Object.assign(this, obj);
  }
}
